export interface Logger {
  error: ( message?: any, ...optionalParams: any[] ) => void;
  warn: ( message?: any, ...optionalParams: any[] ) => void;
  info: ( message?: any, ...optionalParams: any[] ) => void;
  debug: ( message?: any, ...optionalParams: any[] ) => void;
}

const makeLoggerChannel =
  <Props>( component: React.FC<Props>, level: 'error' | 'warn' | 'log' | 'info' | 'debug' ) =>
    ( message?: any, ...optionalParams: any[] ): void => {
      const componentName = component.displayName || component.name || 'Component';
      const messageString = message ? message.toString() : '';
      console[level]( `${componentName}: ${messageString}`, ...optionalParams );
    };

export const useComponentLog = <Props>( component: React.FC<Props> ) => ( {
  debug: makeLoggerChannel( component, 'debug' ),
  info: makeLoggerChannel( component, 'info' ),
  log: makeLoggerChannel( component, 'log' ),
  warn: makeLoggerChannel( component, 'warn' ),
  error: makeLoggerChannel( component, 'error' ),
} );
